import { render, staticRenderFns } from "./ChatMenu.vue?vue&type=template&id=0a1653bd&"
import script from "./ChatMenu.vue?vue&type=script&lang=js&"
export * from "./ChatMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChatMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pedroasilva/Desktop/ioScienceThesis/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VIcon,VList,VListTile})
